<template>
    <div
        class="social-media-link"
        v-if="item"
        v-outsideclick="outsideclick"
        @click="openMore = true"
        @mouseenter="openMore = true"
        @mouseleave="openMore = false"
    >
        <span class="social-head">
            <template v-if="item.hasMore">
                <site-img
                    class="avatar"
                    :src="item.accountIcon || defaultAvatar"
                    :errorImg="defaultAvatar"
                    :alt="`${socialObj.title} avatar`"
                />
                <div class="more-container flex-center">
                    <i class="iconfont icon-more1 more" />
                </div>
            </template>
            <template v-else>
                <a
                    :href="item.link"
                    target="_blank"
                    :aria-label="`${socialObj.title} avatar`"
                    rel="noopener
                        noreferrer"
                >
                    <site-img
                        class="avatar"
                        :src="item.accountIcon || defaultAvatar"
                        :errorImg="defaultAvatar"
                        :alt="`${socialObj.title} avatar`"
                    />
                </a>
            </template>
            <div class="social-type-container flex-center">
                <i
                    v-if="item.socialType != Tiktok_TYPE"
                    class="iconfont source"
                    :class="socialObj.class"
                    :style="socialObj.style"
                ></i>
                <div v-else class="icon-tiktok-round"></div>
            </div>
        </span>
        <div class="account-list" v-if="item.hasMore" v-show="openMore">
            <p class="title">{{ socialObj.title }}</p>
            <a
                v-for="listItem in item.list"
                :key="listItem.link"
                :href="listItem.link"
                class="account-item"
                target="_blank"
                rel="noopener noreferrer"
                :aria-label="`${listItem.accountName} avatar`"
            >
                <site-img
                    class="avatar"
                    :src="listItem.accountIcon || defaultAvatar"
                    :errorImg="defaultAvatar"
                    :alt="`${listItem.accountName} avatar`"
                /><span>{{ listItem.accountName }}</span>
            </a>
        </div>
    </div>
</template>
<script>
const mediaMap = {
    0: {
        style: {
            color: '#384891'
        },
        class: 'icon-facebook-round',
        typelangKey: 'Facebook'
    },
    1: {
        style: {
            'background-image':
                'linear-gradient(44deg, #f7de01 6%, #f92002 40%, #dd1e49 52%, #b12973 62%, #7837aa 87%)',
            'background-clip': 'text',
            '-webkit-background-clip': 'text',
            color: 'transparent'
        },
        class: 'icon-instagram-round',
        typelangKey: 'Instagram'
    },
    2: {
        style: {
            color: '#1daef3'
        },
        class: 'icon-newtwitter-round',
        typelangKey: 'Twitter'
    },
    3: {
        style: {
            color: '#2f8ad9'
        },
        class: 'icon-linkedin-round',
        typelangKey: 'LinkedIn'
    },
    4: {
        style: {
            color: '#ed0a0a'
        },
        class: 'icon-youtube-round',
        typelangKey: 'YouTube'
    },
    5: {
        style: {
            color: '#000000'
        },
        class: 'icon-tiktok-round',
        typelangKey: 'TikTok'
    },
    6: {
        style: {
            color: '#384891'
        },
        class: 'icon-facebook-round',
        typelangKey: 'FacebookGroup'
    },
    7: {
        style: {
            color: '#4ea3f0'
        },
        class: 'icon-google-plus-round',
        typelangKey: 'GoogleBusiness'
    }
};
const Tiktok_TYPE = 5;
export default {
    name: 'SocialMediaLink',
    i18next: {
        ns: 'md-social-post'
    },
    props: {
        item: Object
    },
    data: function() {
        return {
            Tiktok_TYPE,
            openMore: false,
            defaultAvatar: 'https://cdn.chime.me/image/fs/sitebuild/202457/7/original_fbb918b4-831d-43d3-8d96-68f8986a8e79.png'
        };
    },
    computed: {
        socialObj({ item }) {
            if (!item || !mediaMap[item.socialType]) {
                return {};
            }
            let obj = mediaMap[item.socialType];
            return {
                ...obj,
                title: this.$t('md-social-post.' + obj.typelangKey)
            };
        }
    },
    methods: {
        outsideclick() {
            this.openMore = false;
        }
    }
};
</script>
<style style="scss">
.social-media-link {
    position: relative;
    padding-bottom: 10px;
    padding-right: 5px;
    .avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: block;
        margin-bottom: 5px;
    }
    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .social-head {
        position: relative;
        display: block;
        .social-type-container {
            position: absolute;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            right: 0;
            bottom: -5px;
            background: #fff;
        }
        .more-container {
            position: absolute;
            width: 12px;
            height: 12px;
            right: -4px;
            top: -4px;
            border-radius: 50%;
            background: #f0454c;
        }
        .more {
            color: #fff;
            transform: scale(0.6);
        }
        i {
            font-size: 12px;
        }
        .icon-tiktok-round {
            background-image: url(https://cdn.chime.me/image/fs/sitebuild/2022828/19/original_04f465ef-ec7a-486f-a76f-6e2d369319c9.png);
            background-size: contain;
            background-repeat: no-repeat;
            width: 12px;
            height: 12px;
            border-radius: 50%;
        }
    }
    .account-list {
        position: absolute;
        z-index: 3;
        top: 100%;
        left: 0;
        width: 250px;
        background: #fff;
        border: 1px solid #c6c8d1;
        padding: 6px 0;
        border-radius: 4px;
        color: #515666;
        font-size: 14px;
        &::before {
            position: absolute;
            content: '';
            left: 3px;
            top: 0;
            border: 1px solid #c6c8d1;
            width: 8px;
            height: 8px;
            transform: rotate(45deg) translateY(-7px);
            border-right-color: #fff;
            border-bottom-color: #fff;
            background: #fff;
        }
        .title {
            padding: 0 15px;
            font-family: var(--font-bold);
            line-height: 32px;
        }
        .account-item {
            padding: 10px 15px;
            display: flex;
            align-items: center;
            &:hover,
            &:active {
                background: #f6f7fb;
                span {
                    color: var(--color-theme);
                }
            }
        }
        img {
            margin-right: 10px;
        }
    }
}
</style>
